import Image from 'next/image';

const LOGO_WORDMARK_URL =
  'https://aurium-marketing.b-cdn.net/emails/logo-wordmark.png';
const LOGO_ASPECT_RATIO = 4.5;

interface LogoProps {
  height?: number;
}
export const Logo = ({ height = 28 }: LogoProps) => {
  return (
    <Image
      src={LOGO_WORDMARK_URL}
      height={height}
      width={Math.round(height * LOGO_ASPECT_RATIO)}
      style={{ height, width: 'auto' }}
      alt="Aurium"
    />
  );
};
